import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";


// Images
import funder from "../assest/funder.jpg";
import img1 from "../assest/logo/html.png";
import img2 from "../assest/logo/css.png";
import img3 from "../assest/logo/js.png";
import img4 from "../assest/logo/jquery.png";
import img5 from "../assest/logo/php.png";
import img6 from "../assest/logo/sql.png";
import img7 from "../assest/logo/koha.png";
import img8 from "../assest/ZZZZZ2898.jpg";
import img9 from "../assest/why_work_with_us.webp";

import "./about.css";

const About = () => {
  return (
    <div className="about-page">

      {/* ===================== BANNER ===================== */}
      <div className="about-banner">
        <img src={img8} alt="banner" className="banner-img" />
        <div className="banner-text">
          <h1>About Us</h1>
        </div>
      </div>

      {/* ===================== BACKGROUND ANIMATION ===================== */}
      <div className="body-container">
        <div className="bg-blobs"></div>
        <div className="bg-blobs2"></div>
        <div className="floating-dots"></div>

        {/* ===================== ABOUT SECTION ===================== */}
        <section className="about-section">
          <div className="about-blob1"></div>
          <div className="about-blob2"></div>

          <h2 className="section-heading">
            <span className="line"></span> A Few Words About Click Informatics <span className="line"></span>
          </h2>

          <div className="about-wrapper container">
            <div className="row align-items-center">

              {/* Left Text */}
              <div className="col-md-12 about-text fade-in">
                <h3 className="about-title">Company Profile</h3>
                <p>
                  We at Click Informatics believe not just in building websites, we believe in crafting an experience for your Customers through our exclusive designs and by following a brand building process for your product.
                </p>

                <p>
                 Click Informatics is dedicated to provide you the best solutions for your requirements at a very affordable price that are high on standards. As client satisfaction is our foremost goal we ensure that we deliver a positive and identifiable return on every client's investment.
                </p>

                <p>So this casework may help you increase your sales at affordable prices. We candid acquire your requirement.</p>
                
                <h3 className="about-title">My Philosophy on Design</h3>

                <p>
                  Proper web design is what reflects your company or yourself. That's why I'm still successful in what I do. I believe that sites that are designed with human factors in mind are more likely to convert visits to sales, to be bookmarked, and to be visited again in the future ifthe visitor has similar intentions. Here are a few principles that I'm guided by:
                </p>

                <ul>
                  <li>Web sites should be easy to navigate</li>
                  <li>Web pages should load quickly</li>
                  <li>Your web resource should look pleasant and clean</li>
                  <li>Web sites should be viewable on any browser or OS</li>
                </ul>
              </div>
            </div>
          </div>
        
        <div className="row">
          <div className="col-md-6">
                <h3 className="about-title">WHY WORK WITH US?</h3>
                <p>Clean and Unique Design</p>
                <ul>
                  <li>Clean and Unique Design</li>
                  <li>Facilitating communication between viewers and content</li>
                  <li>Enhancing initial positive responses</li>
                  <li>Stands out from the crowd</li>
                </ul>
                <p>We use latest technology</p>
                <ul>
                  <li>Ultra-modern state of the art solutions</li>
                  <li>Advanced and distinguished technology attributes</li>
                  <li>E-Commerce modules such as Magento & PrestaShop</li>
                </ul>
              </div>

              <div className="col-md-6 text-center">
                <img src={img9} alt="About Us" className="about-img" />
              </div>
        </div>

        </section>
        
        {/*funder messages*/}
        <section className="founder-section py-5">
          <div className="container">
            <h2 className="section-heading text-center mb-5">
              <span className="line"></span> 
                Message from Our Founder 
              <span className="line"></span>
            </h2>

            <div className="row align-items-center founder-message">
              <div className="col-md-4 text-center mb-4 mb-md-0">
                <img src={funder} alt="Founder" className="founder-img img-fluid rounded-circle shadow" />
              </div>

              <div className="col-md-8">
                <h3 className="founder-name mb-3">Tarun Sharma</h3>
              <p className="founder-text">
                At Click Informatics, I have always believed that a website is far more than just a digital presence — it is the first experience your customers have with your brand. From the beginning, our mission has been to craft meaningful, impactful, and memorable digital journeys that help businesses connect authentically with their audience. We don’t just build websites; we build identities, experiences, and long-term value through thoughtful design and a strategic brand-building approach.
              </p>
              <p className="founder-text">
                Quality does not always have to come at a high price. At Click Informatics, we are committed to delivering high-standard solutions that remain affordable, practical, and result-oriented. Client satisfaction has always been our foremost priority, and every project we undertake is guided by the belief that our work must generate a clear, measurable return on your investment. When our clients succeed, we succeed.
              </p>
              <p className="founder-text">
                My philosophy on design is simple: good design should feel effortless. A website must reflect your company’s personality, values, and purpose. It should be easy to navigate, visually clean, quick to load, and accessible across all browsers and devices. Most importantly, it should be built with the user in mind. Designs that respect human behavior naturally convert better, leave lasting impressions, and encourage repeat visits.
              </p>
              <p className="founder-text">
                As we continue to grow, my promise is to uphold the same principles that built Click Informatics — integrity, creativity, and a deep commitment to your success. We are here to support your goals, elevate your brand, and help you achieve meaningful digital growth.
              </p>
            </div>
          </div>
        </div>
      </section>


        {/* ===================== TECHNOLOGY SLIDER ===================== */}
        <h2 className="section-heading" style={{ marginTop: "50px" }}>
          <span className="line"></span> Our Technology <span className="line"></span>
        </h2>

        <Swiper
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{ delay: 2000 }}
          modules={[Autoplay]}
          className="tech-slider"
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 5 },
          }}
        >
          <SwiperSlide>
            <div className="card card-img">
              <img src={img1} />
              <h4 className="title">HTML</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img2} />
              <h4 className="title">CSS</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img3} />
              <h4 className="title">JavaScript</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img4} />
              <h4 className="title">JQuery</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img5} />
              <h4 className="title">PHP</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img6} />
              <h4 className="title">MySQL</h4>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="card card-img">
              <img src={img7} />
              <h4 className="title">Koha</h4>
            </div>
          </SwiperSlide>
        </Swiper>

        {/* our team */}
        <div className="team-section mt-5">
          <h2 className="section-heading text-center mb-5">
            <span className="line"></span> Our Team <span className="line"></span>
          </h2>

        <div className="container">
          <div className="row justify-content-center">

          {/* Member 1 */}
          <div className="col-6 col-md-4 col-lg-3 text-center mb-4">
            <div className="team-member">
              <img src={funder} alt="Team Member" className="team-img img-fluid rounded-circle shadow" />
              <h5 className="mt-3 team-name">Mr. Tarun Sharma</h5>
              <p className="team-role">Founder / CEO</p>
            </div>
          </div>

          {/* Member 2 */}
          <div className="col-6 col-md-4 col-lg-3 text-center mb-4">
            <div className="team-member">
              <img src={funder} alt="Team Member" className="team-img img-fluid rounded-circle shadow" />
              <h5 className="mt-3 team-name">Mr. Keshav Gupta</h5>
              <p className="team-role">Project Leaders</p>
            </div>
          </div>

          {/* Member 3 */}
          <div className="col-6 col-md-4 col-lg-3 text-center mb-4">
        <div className="team-member">
          <img src={funder} alt="Team Member" className="team-img img-fluid rounded-circle shadow" />
              <h5 className="mt-3 team-name">Mr. Punit Yadav</h5>
              <p className="team-role">Full Stack Developer</p>
            </div>
          </div>
        </div>
      </div>
    </div>


        {/* ===================== TESTIMONIAL ===================== */}
        <h2 className="section-heading" style={{ marginTop: "60px" }}>
          <span className="line"></span> What Our Customers Say <span className="line"></span>
        </h2>

        <div className="testimonial-section">
          <Swiper
            spaceBetween={30}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 3000 }}
            pagination={{ clickable: true }}
            modules={[Autoplay, Pagination]}
            className="testimonial-slider"
          >
            <SwiperSlide>
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Click Informatics delivered our website exactly as we wanted."
                </p>
                <h4 className="testimonial-name">— Rahul Verma</h4>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Amazing team! They created a modern mobile app for us."
                </p>
                <h4 className="testimonial-name">— Priya Sharma</h4>
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="testimonial-card">
                <p className="testimonial-text">
                  "Very professional and top-quality support."
                </p>
                <h4 className="testimonial-name">— Manish Gupta</h4>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>

      </div>
    </div>
  );
};

export default About;
